exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap);", ""]);

// module
exports.push([module.id, ".v-pagination__item[data-v-08676e6d],.v-pagination__item--active[data-v-08676e6d],.v-pagination__navigation[data-v-08676e6d]{box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 2px 0 rgba(0,0,0,.12)}.v-breadcrumbs[data-v-08676e6d]{font-family:Inter,sans-serif;font-size:12px;font-weight:500;line-height:140%}.v-breadcrumbs a[data-v-08676e6d]{text-decoration:none}", ""]);

// exports
